'use strict';

function CompanyUserStarService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/users/:userId/starred/:publicationId', {}, {
    'add': {
      method:'PUT',
      url: config.apiBase + '/companies/:companyId/users/:userId/starred/:publicationId'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyUserStarService', ['$resource', 'config', CompanyUserStarService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/users/CompanyUserStarService.js
// module id = 45
// module chunks = 0